export const useUsersListViewType = () => {
	let viewTypeSelected = null;

	if (
		typeof window !== "undefined" &&
		typeof localStorage !== "undefined" &&
		localStorage !== null
	) {
		const saved = localStorage.getItem("usersListViewType");
		viewTypeSelected = saved === "grid" || saved === "list" ? saved : null;
	}

	const handleSetViewTypeSelected = (viewType) => {
		if (
			typeof window !== "undefined" &&
			typeof localStorage !== "undefined" &&
			localStorage !== null
		) {
			localStorage.setItem("usersListViewType", viewType);
		}
	};

	return {
		handleSetViewTypeSelected,
		viewTypeSelected,
	};
};
